import React from 'react';

import './develop.scss';
import MsiDatagrid from '../../components/custom/MsiDatagrid';

const strComponent = `{
  "success": true,
  "message": "berhasil mendapatkan data",
  "data": [
    {
      "component-name": "datagrid",
      "link-data": "https://run.mocky.io/v3/2ec8aa52-a01d-4d63-bc3b-16b0138efcd1"
    }
  ]
}`;

const jsoncomponent = JSON.parse(strComponent);

const data = jsoncomponent.data;
const renderItem = (item: any, index: number) => {
  if (item[`component-name`] == 'datagrid') {
    return (
      <MsiDatagrid key={index} />
    )
  } else {
    return (
      <div key={index} style={{ color: 'red' }}>
        <strong>Fitur Belum Tersedia</strong>
      </div>
    );
  }
}

export default () => (
  <React.Fragment>
    <h2>TABEL</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        {data.map((item: any, index: number) => renderItem(item, index))}
      </div>
    </div>
  </React.Fragment>
);
